<app-student-teacher-details [studentId]="studentId" [teacherId]="teacherId" [langCode]="langCode"></app-student-teacher-details>